import { render, staticRenderFns } from "./map.vue?vue&type=template&id=70271a66&scoped=true"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"
import style0 from "./map.vue?vue&type=style&index=0&id=70271a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70271a66",
  null
  
)

export default component.exports